module.exports = __webpack_public_path__ + "0c4cf582176772cb10bb08b3525602f8.pdf";